/**
 * Datos NO traducibles: correos, teléfonos, URLs, identificadores, config general.
 * Los textos visibles al usuario viven en src/i18n/locales. Ver docs/PLAN.md §5.1.
 */
export const siteConfig = {
  name: 'Psicointegralis',
  legalName: 'Psicointegralis S.C.',
  location: 'Morelos, México',
  contact: {
    email: 'contacto@psicointegralis.org',
    // Formato E.164 sin símbolos, para enlaces wa.me
    whatsapp: '527772603831',
    phones: ['527772603831', '525587934791', '525646184500'],
  },
  social: {
    instagram: 'https://instagram.com/psicointegralis.mx',
    facebook: 'https://facebook.com/psicointegralis',
  },
} as const;

/** URL lista para abrir WhatsApp con un mensaje opcional. */
export function whatsappUrl(message?: string): string {
  const base = `https://wa.me/${siteConfig.contact.whatsapp}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
